import React, { useState, useEffect } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { gemtechTextLogo } from "assets";
import {
  FaLinkedin,
  // FaSquareFacebook,
  // FaSquareXTwitter,
  // FaYoutube,
} from "react-icons/fa6";
import { HiPhone } from "react-icons/hi";
import { useMediaQuery } from "react-responsive";
import { IoIosArrowUp, IoMdMail } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";

const Footer = () => {
  const large = useMediaQuery({ query: "(min-width: 992px)" });
  const [showComponent, setShowComponent] = useState(false);

  const resources = [
    { id: 1, title: "Home", route: "/" },
    { id: 2, title: "Solutions", route: "/solutions" },
    { id: 3, title: "About Us", route: "/about-us" },
    // { id: 4, title: "Clients", route: "/clients" },
    { id: 5, title: "Contact Us", route: "/contact-us" },
  ];

  const solutions = [
    { id: 1, title: "Consultancy", route: "/solutions/consultancy" },
    { id: 2, title: "Granulation", route: "/solutions/granulation" },
    { id: 3, title: "Tableting", route: "/solutions/tableting" },
    { id: 4, title: "Coating", route: "/solutions/coating" },
    { id: 5, title: "Encapsulation", route: "/solutions/encapsulation" },
    { id: 6, title: "Blister Packing & Cartoning", route: "/solutions/blister-packing-and-cartoning" },
    { id: 7, title: "Liquid Filling", route: "/solutions/liquid-filling" },
    { id: 8, title: "Change Parts & Spare Parts", route: "/solutions/change-parts-and-spare-parts" },
  ];

  const policies = [
    { id: 1, title: "Privacy Policy", route: "/privacy-policy" },
  ];

  const socialMedia = [
    {
      id: 1,
      title: "LinkedIn",
      icon: <FaLinkedin size={32} color="#000000" />,
      route: "https://www.linkedin.com/company/gemtechsolutions/",
    },
    // {
    //   id: 2,
    //   title: "Twitter",
    //   icon: <FaSquareXTwitter size={32} color="#000000" />,
    //   route: "/",
    // },
    // {
    //   id: 3,
    //   title: "Youtube",
    //   icon: <FaYoutube size={32} color="#000000" />,
    //   route: "/",
    // },
    // {
    //   id: 4,
    //   title: "Facebook",
    //   icon: <FaSquareFacebook size={32} color="#000000" />,
    //   route: "/",
    // },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const scrollThreshold = 1 * window.innerHeight;

      if (scrollY > scrollThreshold) {
        setShowComponent(true);
      } else {
        setShowComponent(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Container
      fluid
      className="pt-5 text-white bg-primary"
    >
      <div
        className={`d-flex ${large ? "justify-content-between" : "flex-column"
          }`}
        style={large ? styles.largeScreenPadding : { padding: 10 }}
      >
        <div className="me-3 mb-lg-0 mb-4">
          <div className="text-center mb-5 d-flex justify-content-start">
            <Image src={gemtechTextLogo} style={{ width: large ? 200 : 100 }} />
          </div>
          <h5 className="subtitle pe-lg-4 text-black mb-4" style={{ fontWeight: 600 }}>
            Contact Details
          </h5>
          <a
            href="tel:+91 99303 29749"
            className="d-flex justify-lg-content-center align-items-center p-lg-0 mb-3"
            style={{ textDecoration: "none" }}
          >
            <span className="d-flex justify-content-center align-items-center text-black border-0">
              <IoLocationSharp />
            </span>
            <b className="text-black ms-2">Thane - 400615</b>
          </a>
          <a
            href="tel:+91 99303 29749"
            className="d-flex justify-lg-content-center align-items-center p-lg-0 mb-3"
            style={{ textDecoration: "none" }}
          >
            <span className="d-flex justify-content-center align-items-center text-black border-0">
              <HiPhone />
            </span>
            <b className="text-black ms-2">+91 99303 29749</b>
          </a>
          <a
            href="mailto:info@gemtechs.in"
            className="d-flex justify-lg-content-center align-items-center p-lg-0"
            style={{ textDecoration: "none" }}
          >
            <span className="d-flex justify-content-center align-items-center text-black border-0">
              <IoMdMail />
            </span>
            <b className="text-black ms-2">info@gemtechs.in</b>
          </a>
        </div>
        <div className="me-3">
          <h5 className="subtitle pe-lg-4 text-black" style={{ fontWeight: 600 }}>
            Resources
          </h5>
          {resources.map((col) => {
            return (
              <div className="my-4">
                <a
                  href={col.route}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <p className="footer-info footer-link">{col.title}</p>
                </a>
              </div>
            );
          })}
        </div>
        <div className="me-3">
          <h5 className="subtitle pe-lg-4 text-black" style={{ fontWeight: 600 }}>
            Solutions
          </h5>
          {solutions.map((col) => {
            return (
              <div className="my-4">
                <a
                  href={col.route}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <p className="footer-info footer-link">{col.title}</p>
                </a>
              </div>
            );
          })}
        </div>
        <div className="me-3">
          <h5 className="subtitle pe-lg-4 text-black" style={{ fontWeight: 600 }}>
            Policies
          </h5>
          {policies.map((col) => {
            return (
              <div className="my-4">
                <a
                  href={col.route}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <p className="footer-info footer-link">{col.title}</p>
                </a>
              </div>
            );
          })}
        </div>
        <div className="me-3">
          <h5 className="subtitle text-black" style={{ fontWeight: 600 }}>
            Social Connects
          </h5>
          <Row lg={3} className="mt-3">
            {socialMedia.map((social) => {
              return (
                <Col className="mb-3 p-lg-0 p-2">
                  <a
                    href={social.route}
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    {social.icon}
                  </a>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>

      <div
        className={`pb-4 ${large ? "d-flex justify-content-center align-items-center" : "mt-4"}`}
        style={{ right: 0, top: 0 }}
      >
        <span className="footer-info footer-link">{`© 2024 Gemtech Solutions All Rights Reserved`}</span>
      </div>
      <div className={`${showComponent ? "" : "d-none"}`}>
        <div
          className="d-flex text-primary my-2 my-lg-4 cursor-pointer bg-white border border-primary"
          style={{
            textDecoration: "none",
            scrollBehavior: "smooth",
            position: window.scrollY > 200 ? "fixed" : "static",
            bottom: window.scrollY > 200 ? "20px" : "auto",
            right: window.scrollY > 200 ? "20px" : "auto",
            padding: "12px",
            backgroundColor: "#1B1E29",
            borderRadius: "25px",
          }}
          onClick={() => window.scrollTo(0, 0)}
        >
          <IoIosArrowUp size={20} />
        </div>
      </div>
    </Container>
  );
};

const styles = {
  largeScreenPadding: {
    paddingLeft: 100,
    paddingRight: 100,
  },
};

export default Footer;
